module.exports = __webpack_public_path__ + "media/images/ln/constellation_10-9bbb398c29d91c3d99c5058d6fac9a82.png";